import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

export interface PushScreenRefreshEvent {
  path: string;
  data: Record<string, any>;
}

@Injectable({
  providedIn: "root",
})
export class PushScreenRefreshService {
  private readonly refreshSubject = new Subject<PushScreenRefreshEvent>();

  readonly refresh$ = this.refreshSubject.asObservable();

  emit(path: string, data: Record<string, any>): void {
    this.refreshSubject.next({ path, data });
  }
}
